import axios from 'axios'

import { API_URL } from '../config'
import { store } from '../redux/store'

import { csrfToken, sessionId, sessionToken } from './cookies'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.request.use(
  (config) => {
    const userId = store.getState().auth.userId

    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    }
    if (sessionId) {
      config.headers['X-Session-ID'] = sessionId
    }
    if (sessionToken) {
      config.headers['X-Session-Token'] = sessionToken
    }
    if (config.data instanceof FormData) {
      if (userId) {
        config.data.append('user_id', userId)
      }
    } else if (typeof config.data === 'object' && userId) {
      config.data = {
        ...config.data,
        user_id: userId,
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default api
